import React from 'react';
import { CSSObject } from 'styled-components';
import { BottomNavStyled } from './bottom.styled';

interface BottomNavProps {
  sx?: CSSObject;
  value: string;
  onClick: () => void;
  children?: React.ReactNode | React.ReactNode[];
}

const BottomNav = ({ value, onClick, children, ...rest }: BottomNavProps) => {
  return (
    <BottomNavStyled {...rest}>
      {React.Children.map(children, (child: React.ReactElement, index) => {
        if (child) {
          const childValue =
            child.props.value === undefined ? String(index) : child.props.value;

          return React.cloneElement(child, {
            active: value === childValue,
            onClick,
            ...child.props,
          });
        }
      })}
    </BottomNavStyled>
  );
};

export default BottomNav;
